import { LIBRARIES, loadLibrary } from './libs-loader';

export const getGaTracker = (function getGaTracker() {
  const trackers = {};

  window.ga = window.ga || function tempGA(...args) {
    (window.ga.q = window.ga.q || []).push(args);
  };
  window.ga.l = +new Date();

  return (trackerId, options) => {
    if (trackers[trackerId]) {
      return trackers[trackerId];
    }

    window.ga('create', trackerId, options);
    trackers[trackerId] = (command, ...args) => {
      const commandName = options && options.name ? `${options.name}.${command}` : command;

      window.ga(commandName, ...args);
    };

    loadLibrary(LIBRARIES.GOOGLE_ANALYTICS).catch(() => {
      console.warn('Google Analitics has an issue while loading...');
    });

    return trackers[trackerId];
  };
}());
